import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/Subscription';

import {
  AreaParticipacaoModel,
  AreaParticipacaoService,
  MunicipioModel,
  MunicipioService,
  NbpConfirmComponent,
  NbpInfoComponent,
  UtilHelper,
} from '../../../shared/';
import { InstituicaoModel, InstituicaoService } from '../../instituicao/shared/';
import { FiltroInstituicao } from '../../instituicao/shared/filtro-instituicao';
import { ConsumidorModel, ConsumidorService } from '../shared/';

import { Observable, Subject } from 'rxjs';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap, filter } from 'rxjs/operators';
import { KeyboardValidator } from '../../../shared/validators/keyboard-validator';
import { FiltroBuscaMunicipios } from '../../../shared/filter/filtro-municipios';
import { FiltroBuscaInstituicoes } from '../../instituicao/shared/filtro-busca-instituicoes';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { FiltroConsistenciaConsumidor } from '../../../shared/filter/filtro-consistencia-consumidor';

@Component({
  selector: 'app-consumidor-instituicao',
  templateUrl: './consumidor-instituicao.component.html',
  styleUrls: ['./consumidor-instituicao.component.css']
})
export class ConsumidorInstituicaoComponent implements OnInit, OnDestroy {
  @ViewChild('instSelecionadas') public myScrollContainer: ElementRef;

  // Elementos da busca dos municípios
  public listagemMunicipios$: Observable<MunicipioModel[]>;
  public municipiosLoading = false;
  public municipioInput$ = new Subject<string>();
  public selectedMunicipio: MunicipioModel;

  // Elementos da busca das instituições
  public listagemInstituicoes$: Observable<InstituicaoModel[]>;
  public instituicoesLoading = false;
  public instituicaoInput$ = new Subject<string>();
  public selectedInstituicao: InstituicaoModel;

  public unsubInstituicoesChange: Subscription;
  public unsubAreasPartChange: Subscription;
  public unsubMunicipioChange: Subscription;
  public unsubConsumidorChange: Subscription;
  public unsubInstSelectForm: Subscription;
  public unsubMunicipioService: Subscription;

  public instituicoesSelecionadas: InstituicaoModel[] = [];
  public instituicoes: InstituicaoModel[];
  public areasParticipacao: AreaParticipacaoModel[];
  public areasSelecionadas: AreaParticipacaoModel[] = [];
  public consumidor: ConsumidorModel;
  public mensagemSemestre: string;
  public instituicaoInconsitente: string;

  formErrors = {
    errosSelecao: [],
    instituicaoNaoEncontrada: [],
  };

  validationMessages = {
    areaJaInserida: 'Já existe uma instituição com a área de participação selecionada;',
    instituicaoJaInserida: 'A instituição selecionada já foi inserida como favorida.',
    instituicaoNaoSelecionada: 'Selecione uma instituição da lista pesquisada.',
    instituicaoNaoEncontrada: 'Não foram encontradas instituições com os dados informados.',
    semFiltros: 'Informe pelo menos um dos campos: Município, Área ou Nome Instituição',
    erroBuscaInstituicao: 'Ocorreu um erro ao pesquisar pela instituição desejada.',
    erroBuscaMunicipios: 'Ocorreu um erro ao pesquisar pelo município desejado.',
  };

  public instSelectForm: FormGroup;

  public pagina = 1;
  public tamanhoPagina = 10;
  public totalInstituicoes = 0;
  public areaParticipacao = '';
  public tipoOperacaoList = {
    insert: 1,
    update: 2,
    delete: 3
  };
  public tipoOperacao: number;

  @Input() breadcrumbInstituicao = true;

  @Output() public OnInstituicaoSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

  // Atributos utilizados para funcionalidade de edição da lista de instituições.
  public instituicaoEdit: InstituicaoModel;
  public instituicaoIndexEdit: number;

  constructor(
    private readonly consumidorService: ConsumidorService,
    private readonly instituicaoService: InstituicaoService,
    private readonly areaParticipacaoService: AreaParticipacaoService,
    private readonly municipioService: MunicipioService,
    private readonly ngbModalService: NgbModal,
  ) {
    this.instituicaoIndexEdit = null;
    this.tipoOperacao = this.tipoOperacaoList.insert;

    this.instituicaoInconsitente = consumidorService.mn0030;
  }

  ngOnInit() {
    this.mensagemSemestre = this.consumidorService.instituicaoDesativada;

    this.unsubConsumidorChange = this.consumidorService.consumidorChange.subscribe(data => {
      this.consumidor = data;

      if (this.consumidorService.getEditMode()) {
        this.instituicoesSelecionadas = this.consumidor.instituicoes;
      }
    });

    this.consumidor = this.consumidorService.getConsumidorModel();

    if (this.consumidorService.getEditMode()) {

      this.consumidorService.getInstituicoesPeloCPF(
        `${UtilHelper.lpad(this.consumidor.cpfBase.toString(), 9)}` + `${UtilHelper.lpad(this.consumidor.cpfDigito.toString(), 2)}`
      );

    }

    this.instSelectForm = new FormGroup({
      areaParticipacao: new FormControl(''),
      codArea: new FormControl('')
    });

    // Inicio o observador que monitora mudança na lista de instituições retornadas pela webapi
    this.unsubInstituicoesChange = this.instituicaoService.instituicoesChange.subscribe((instituicoes: InstituicaoModel[]) => {
      this.instituicoes = instituicoes;
      this.totalInstituicoes = this.instituicaoService.totalInstituicoes;
      if (this.instituicoes.length <= 0) {
        this.formErrors.instituicaoNaoEncontrada.push(this.validationMessages.instituicaoNaoEncontrada);
      }
      this.instituicaoInconsitente = '';
      this.consumidorService.mn0030 = '';
    });

    // Inicio o observador que monitora mudança na lista de areas participacoes
    this.unsubAreasPartChange = this.areaParticipacaoService.areasParticipacaoChange.subscribe(
      (areasParticipacao: AreaParticipacaoModel[]) => {
        try {
          this.areasParticipacao = areasParticipacao;

          if (this.consumidor.instituicoes && this.consumidor.instituicoes.length === 1) {
            this.limpaComboArea(this.consumidor.instituicoes[0]);
          }
        } catch (error) {
          console.log('================================================');
          console.log('============ unsubAreasPartChange : ' + error);
        }
      }
    );

    this.areaParticipacaoService.getAreasParticipacao();

    this.unsubInstSelectForm = this.instSelectForm.valueChanges.subscribe(data => {
      this.formErrors.instituicaoNaoEncontrada = [];
      this.mensagemSemestre = '';
    });

    this.AtivarBuscaInteligente();
  }

  tratarAlteracaoInstituicao(instituicoes) {
    let mensagem = 'Inclusão realizada com sucesso.';

    if (this.tipoOperacao === this.tipoOperacaoList.update) {
      mensagem = 'Alteração realizada com sucesso.';
    }

    if (this.tipoOperacao === this.tipoOperacaoList.delete) {
      mensagem = 'Exclusão realizada com sucesso.';
    }

    if (this.consumidorService.getEditMode()) {
      this.consumidor.instituicoes = instituicoes;
      this.consumidor.cpf = `${UtilHelper.lpad(this.consumidor.cpfBase.toString(), 9)}${UtilHelper.lpad(
        this.consumidor.cpfDigito.toString(),
        2
      )}`;
      this.relizaOperacaoAsyncInstituicao(this.consumidor, mensagem);
    } else {
      this.consumidor.instituicoes = instituicoes;
    }

    this.OnInstituicaoSelected.emit(true);

    this.tipoOperacao = this.tipoOperacaoList.insert;
  }

  relizaOperacaoAsyncInstituicao(consumidor: ConsumidorModel, mensagem: string = '') {
    let confirmModal;

    this.consumidorService.putInstituicoes(this.consumidor, mensagem).subscribe(
      data => {
        confirmModal = this.ngbModalService.open(NbpInfoComponent);
        if (!mensagem) {
          confirmModal.componentInstance.info = 'Alteração realizada com sucesso.';
        } else {
          confirmModal.componentInstance.info = mensagem;
        }
        this.consumidorService.setConsumidorModel(consumidor);
        this.instituicaoService.setInstituicoesSelecionadas(this.instituicoesSelecionadas);
      },
      error => {

        this.consumidorService.getInstituicoesPeloCPF(
          `${UtilHelper.lpad(this.consumidor.cpfBase.toString(), 9)}` + `${UtilHelper.lpad(this.consumidor.cpfDigito.toString(), 2)}`
        );

        this.limpaComboArea(this.consumidor.instituicoes[0]);

        let err = error as StatusRequisicao;
        this.mensagemSemestre = err.motivo;
      }
    );
  }

  ngOnDestroy() {
    this.unsubInstituicoesChange.unsubscribe();
    this.unsubAreasPartChange.unsubscribe();
    this.unsubConsumidorChange.unsubscribe();
    this.unsubInstSelectForm.unsubscribe();
  }

  onSubmit() {
    this.Pesquisar();
  }

  private Pesquisar() {
    this.formErrors = {
      errosSelecao: [],
      instituicaoNaoEncontrada: [],
    };

    this.OnInstituicaoSelected.emit(true);
    this.mensagemSemestre = '';
    this.instituicaoInconsitente = '';
    this.pageChange(1);
  }

  pageChange(event: number): void {
    this.pagina = event;
    this.formErrors.instituicaoNaoEncontrada = [];

    let objFiltro: FiltroInstituicao = {
      municipio: this.ObterCodigoMunicipio(),
      area: this.instSelectForm.controls['areaParticipacao'].value,
      razaosocial: this.ObterNomeInstituicao(),
      page: this.pagina,
      pageSize: this.tamanhoPagina
    };

    if (!objFiltro.area && !objFiltro.municipio && !objFiltro.razaosocial) {
      this.formErrors.instituicaoNaoEncontrada.push(this.validationMessages.semFiltros);
    } else {
      this.instituicaoService.getInstituicoesFavoritas(objFiltro);
    }
  }

  onSelectInstituicao() {
    const indexInstituicao = this.instSelectForm.value['codArea'];
    const instituicao: InstituicaoModel = this.instituicoes[indexInstituicao];

    this.formErrors.errosSelecao = [];
    if (!instituicao) {
      this.formErrors.errosSelecao.push(this.validationMessages.instituicaoNaoSelecionada);
      return false;
    }

    // Verifico se não esta em modo de edição pois a instituição selecionada precisa ser substituida na lista
    if (this.instituicaoIndexEdit !== null) {
      this.instituicoesSelecionadas.splice(this.instituicaoIndexEdit, 1);
      this.alteraInstituicaoSelecionada();
      this.instituicaoEdit = null;
      this.instituicaoIndexEdit = null;
    } else {
      // Inclusão simples da nova instituição na lista de instituições selecionadas
      if (this.validaAreaInstituicaoSelect(instituicao) && this.validaInstituicaoUnica(instituicao)) {
        this.alteraInstituicaoSelecionada();
      }
    }
    this.LimparItensPesquisa();
    return true;
  }

  private LimparItensPesquisa() {

    // Elementos da busca dos municipios
     this.municipioInput$ = new Subject<string>();
     this.listagemMunicipios$ =  null;
     this.selectedMunicipio = null;
     this.municipiosLoading = false;

    // Elementos da busca das instituições
     this.instituicaoInput$ = new Subject<string>();
     this.listagemInstituicoes$ =  null;
     this.selectedInstituicao = null;
     this.instituicoesLoading = false;

     this.AtivarBuscaInteligente();
  }

  private AtivarBuscaInteligente(){
     // Inicializa/Reinicializa os itens de busca para que 
     // novas buscas possam ser realizadas
     this.CarregarBuscaInstituicoes();
     this.CarregarBuscaMunicipios();
  }

  alteraInstituicaoSelecionada() {
    const indexInstituicao = this.instSelectForm.value['codArea'];
    const instituicao: InstituicaoModel = this.instituicoes[indexInstituicao];

    this.instituicoes.splice(indexInstituicao, 1);

    if (!this.instituicoesSelecionadas) {
      this.instituicoesSelecionadas = [];
    }

    // adiciona a instituicao a lista local do componente
    this.instituicoesSelecionadas.push(instituicao);

    // limpa a listatem das instituições do grid
    this.instituicoes = null;

    // limpar formulário
    this.instSelectForm.setValue({
      areaParticipacao: '',
      codArea: ''
    });

    this.limpaComboArea(instituicao);

    this.tratarAlteracaoInstituicao(this.instituicoesSelecionadas);
  }

  limpaComboArea(instituicao: InstituicaoModel) {
    let indexInstiuicao = 0;

    try {
      const areasParticipacaoAux: AreaParticipacaoModel[] = this.areasParticipacao.slice();

      for (const areaParticipacao of this.areasParticipacao) {
        if (areaParticipacao.id === instituicao.areaParticipacaoId) {
          this.areasSelecionadas.push(areaParticipacao);
        } else {
          this.instSelectForm.patchValue({
            areaParticipacao: areaParticipacao.id
          });
        }
        indexInstiuicao++;
      }

      this.instSelectForm.get('areaParticipacao').disable();
      this.areasParticipacao = areasParticipacaoAux.slice();
    } catch (error) {
      console.log('limpaComboArea ' + error);
    }
  }

  ajustarCombo(instiuicao: InstituicaoModel) {
    if (this.instituicoesSelecionadas && this.instituicoesSelecionadas.length > 1) {
      const instituicaoOposta: InstituicaoModel = this.instituicoesSelecionadas.filter(i => i.cnpjBase !== instiuicao.cnpjBase)[0];

      this.limpaComboArea(instituicaoOposta);
    }
  }

  onAlteraInstituicaoSelecionada(instituicao: InstituicaoModel) {
    const confirmModal = this.ngbModalService.open(NbpConfirmComponent, { size: 'lg' });
      confirmModal.componentInstance.mensagem = 'A partir da alteração da instituição, os seus documentos fiscais passarão a ser compartilhados com a nova instituição escolhida, e você continuará participando normalmente dos sorteios mensais e especial.';
      confirmModal.componentInstance.userConfirmChange
        .subscribe(
        (userConfirm) => {
          if (userConfirm) {
            if (this.consumidorService.getEditMode()) {

              let filtro = new FiltroConsistenciaConsumidor(this.consumidor.consumidorId, instituicao.areaParticipacaoId);
      
              this.instituicaoService.getPermissaoAltercao(filtro).subscribe(
                data => {
                  this.realizarAlteracao(instituicao);
                },
                erro => {
                  let err = erro as StatusRequisicao;
                  this.mensagemSemestre = err.motivo;
                }
              );
      
           }else{
            this.realizarAlteracao(instituicao);
           }
          }
        }
        );
  }

  realizarAlteracao(instituicao: InstituicaoModel) {
    const index = this.instituicoesSelecionadas.indexOf(instituicao);

    this.tipoOperacao = this.tipoOperacaoList.update;
    this.limpaComboArea(instituicao);

    this.instituicaoEdit = instituicao;
    this.instituicaoIndexEdit = index;

    this.instSelectForm.get('areaParticipacao').disable();

    this.instSelectForm.patchValue({
      areaParticipacao: instituicao.areaParticipacaoId
    });
  }

  onRemoveInstituicaoSelecionada(indexInstiuicao: number) {
    const confirmModal = this.ngbModalService.open(NbpConfirmComponent, { size: 'lg' });
      confirmModal.componentInstance.mensagem = 'A partir da exclusão da instituição, seus documentos fiscais deixarão de ser compartilhados, mas você continuará participando normalmente dos sorteios mensais e especial.';
      confirmModal.componentInstance.userConfirmChange
        .subscribe(
        (userConfirm) => {
          if (userConfirm) {
            this.tipoOperacao = this.tipoOperacaoList.delete;
            const instituicao: InstituicaoModel = this.instituicoesSelecionadas[indexInstiuicao];

            if (this.consumidorService.getEditMode()) {

              console.log("EditMode=True");

            let filtro = new FiltroConsistenciaConsumidor(this.consumidor.consumidorId, instituicao.areaParticipacaoId);

            this.instituicaoService.getPermissaoAltercao(filtro).subscribe(
              data => {
                this.realizarExclusao(instituicao, indexInstiuicao);
              },
              erro => {
                let err = erro as StatusRequisicao;
                this.mensagemSemestre = err.motivo;
              }
            );

            }else{
              this.realizarExclusao(instituicao, indexInstiuicao);
              console.log("EditMode=False");
            }
          }
        }
        );

  }

  realizarExclusao(instituicao: InstituicaoModel, indexInstiuicao: number) {
    const confirmModal = this.ngbModalService.open(NbpConfirmComponent, { size: 'lg' });
    confirmModal.componentInstance.mensagem = 'Você tem certeza que deseja remover esta instituição?';

    this.ajustarCombo(instituicao);

    confirmModal.componentInstance.userConfirmChange.subscribe(userConfirm => {
      try {
        if (userConfirm) {
          this.instituicoesSelecionadas.splice(indexInstiuicao, 1);

          const areaSelecionada = this.areasSelecionadas.filter(a => a.id === instituicao.areaParticipacaoId)[0];
          const indexAreaSelecionada: number = this.areasSelecionadas.indexOf(areaSelecionada);

          // remove a area das areasSelecionadas e adiciona na areasParticipacao
          this.areasParticipacao.push(this.areasSelecionadas.splice(indexAreaSelecionada, 1)[0]);

          if (this.areasParticipacao && +this.areasParticipacao.length === 1) {
            this.instSelectForm.patchValue({
              areaParticipacao: areaSelecionada.id
            });
          }

          this.tratarAlteracaoInstituicao(this.instituicoesSelecionadas);

          if (+this.instituicoesSelecionadas.length === 0) {
            this.instSelectForm.get('areaParticipacao').enable();
          }
        }
      } catch (error) {
        console.log('unsubConfirm: ' + error);
      }
    });
  }

  validaAreaInstituicaoSelect(instituicao: InstituicaoModel): boolean {
    let areaUnica = true;
    this.formErrors.errosSelecao = [];

    const instituicoesNaMesmaArea: InstituicaoModel[] = this.instituicoesSelecionadas.filter(
      i => i.areaParticipacaoId === instituicao.areaParticipacaoId
    );

    if (instituicoesNaMesmaArea.length !== 0) {
      areaUnica = false;
      this.formErrors.errosSelecao.push(this.validationMessages.areaJaInserida);
    }

    return areaUnica;
  }

  validaInstituicaoUnica(instituicao: InstituicaoModel): boolean {
    let instituicaoUnica = true;
    this.formErrors.errosSelecao = [];

    if (this.instituicoesSelecionadas.length > 0) {
      // filtra instituicao pela chave primaria
      const instituicoesEncontradas: InstituicaoModel[] = this.instituicoesSelecionadas.filter(
        i =>
          i.escolaId === instituicao.escolaId &&
          i.cnpjBase === instituicao.cnpjBase &&
          i.cnpjFilial === instituicao.cnpjFilial &&
          i.cnpjDigito === instituicao.cnpjDigito &&
          i.areaParticipacaoId === instituicao.areaParticipacaoId
      );
      if (instituicoesEncontradas.length !== 0) {
        instituicaoUnica = false;

        this.formErrors.errosSelecao.push(this.validationMessages.instituicaoJaInserida);
      }
    }

    return instituicaoUnica;
  }

  goTo(location: string): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {
      console.log(err);
    }
  }

private CarregarBuscaMunicipios() {
  this.listagemMunicipios$ = concat(
      of([]), // default items
      this.municipioInput$.pipe(
          debounceTime(500),
          distinctUntilChanged(),
          // Não permite buscas se apenas espaço vazio
          filter(searchMunicipios => searchMunicipios && searchMunicipios.trim().length > 0), 
          tap(() => this.municipiosLoading = true),         
          switchMap(searchMunicipios => 
            this.municipioService.getListagemMunicipios(new FiltroBuscaMunicipios("BA", searchMunicipios)).pipe(
              catchError(error => {
              
                    // 500 - Erro Interno
                    if(error.status === 500) {
                      this.LimparElementosBusca();
                      this.formErrors.instituicaoNaoEncontrada.push(this.validationMessages.erroBuscaMunicipios);
                    }
                    return of([]); // Lista vazia em caso de erro               
               }), 
              tap(() => this.municipiosLoading = false)
          ))
      )
  );
}

  private CarregarBuscaInstituicoes() {
      this.listagemInstituicoes$ = concat(
          of([]), // default items
          this.instituicaoInput$.pipe(
              debounceTime(500),
              distinctUntilChanged(),
              // Não permite buscas se apenas espaço vazio
              filter(searchInstituicoes => searchInstituicoes && searchInstituicoes.trim().length > 0), 
              tap(() => this.instituicoesLoading = true),
              switchMap(searchInstituicoes => 
                this.instituicaoService.getListagemInstituicoes(new FiltroBuscaInstituicoes(this.ObterCodigoMunicipio(), this.ObterCodigoAreaParticipacao(), searchInstituicoes)).pipe(
                  catchError(error => {

                    // 500 - Erro Interno
                    if(error.status === 500) {
                      this.LimparElementosBusca();
                      this.formErrors.instituicaoNaoEncontrada.push(this.validationMessages.erroBuscaInstituicao);
                    }

                    return of([]); // Lista vazia em caso de erro
                  }), 
                  tap(() => this.instituicoesLoading = false)
              ))
          )
      );
  }

  private ObterCodigoMunicipio() {
        return this.selectedMunicipio ? this.selectedMunicipio.municipioId : undefined;
  }
  
  private ObterCodigoAreaParticipacao() {
        return this.instSelectForm.controls['areaParticipacao'].value ? this.instSelectForm.controls['areaParticipacao'].value : "";
  }

  private ObterNomeInstituicao() {

    // Retornando null diretamente estava havendo problemas com o método da API
    // O mesmo recebia "null" o que gerava problemas nas buscas, da forma atual
    // a API recebe null, trazendo dessa forma os resultados da forma devida
    return this.selectedInstituicao ? this.selectedInstituicao.nome : '';
  }
  
  public PesquisarInstituicao() {
      if(this.selectedInstituicao) {
          this.LimparElementosBusca();    
          this.Pesquisar();
      }
  }

  public PesquisarArea(){
      this.LimparElementosBusca();
  }

  public PesquisarMunicipio(){
      this.LimparElementosBusca();
  }

  public LimparElementosBusca() {
    this.LimparListaErros();
    
  }

  private LimparListaErros() {
    this.formErrors.instituicaoNaoEncontrada = [];
  }
  
  public ControleTamanhoCampo(event: any, tamanhoPermitido: number){
     KeyboardValidator.onKeydownControleTamanhoCampo(event, tamanhoPermitido);
 }

public LimparBuscasPreviasDeMunicipio() {

  // Limpa os itens responsáveis pelos resultados anteriores que permaneciam no dropdown
  this.listagemMunicipios$ = null;

  // Reinicializa a busca inteligente para permitir novas buscas
  this.CarregarBuscaMunicipios();
}

public LimparBuscasPreviasDeInstituicoes(){

    // Limpa os itens responsáveis pelos resultados anteriores que permaneciam no dropdown
    this.listagemInstituicoes$ = null;

    // Reinicializa a busca inteligente para permitir que novas buscas sejam realizadas
    this.CarregarBuscaInstituicoes();
}

public verificaInstituicoes(instituicoesSelecionadas: InstituicaoModel[]) {
  if(instituicoesSelecionadas.length == 1 && instituicoesSelecionadas.find(i => i.codigoSituacaoInstituicao == 2)){
    return false;
  }
  return true;
}

}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-instituicao/consumidor-instituicao.component.ts